export default "__VITE_ASSET__DtfA6KtP__"